import { AI_IMAGE_SIZE_2K, AI_IMAGE_SIZE_4K } from '../constants';
import type { AiImageAspectRatioId, AiImageResolution } from '../types';

export function getBaseSize(
  aspectRatio: AiImageAspectRatioId,
  resolution: AiImageResolution
): { width: number; height: number } {
  const table = resolution === '2k' ? AI_IMAGE_SIZE_2K : AI_IMAGE_SIZE_4K;
  return { ...table[aspectRatio] };
}

export function formatImageSize(width: number, height: number): string {
  return `${Math.round(width)}x${Math.round(height)}`;
}

export function scaleHeightFromWidth(
  width: number,
  aspectRatio: AiImageAspectRatioId
): number {
  const base = AI_IMAGE_SIZE_2K[aspectRatio];
  return Math.round((width * base.height) / base.width);
}

export function scaleWidthFromHeight(
  height: number,
  aspectRatio: AiImageAspectRatioId
): number {
  const base = AI_IMAGE_SIZE_2K[aspectRatio];
  return Math.round((height * base.width) / base.height);
}
